/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 14L22 2M10 14V9M10 14H15M22 2H17M22 2V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 2H10.5H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V13.5V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H22V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				fill="currentColor"
			/>
			<path
				d="M11 2H10.5H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V13.5V13M10 14L22 2M10 14V9M10 14H15M22 2H17M22 2V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.25 2C16.25 2.41421 16.5858 2.75 17 2.75H20.1893L16.7152 6.22413C16.4966 6.06311 16.2642 5.91942 16.02 5.79497C14.9504 5.25 13.5503 5.25 10.75 5.25H9.25C6.44974 5.25 5.04961 5.25 3.98005 5.79497C3.03924 6.27433 2.27433 7.03924 1.79497 7.98005C1.25 9.04961 1.25 10.4497 1.25 13.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H10.75C13.5503 22.75 14.9504 22.75 16.02 22.205C16.9608 21.7257 17.7257 20.9608 18.205 20.02C18.75 18.9504 18.75 17.5503 18.75 14.75V13.25C18.75 10.4497 18.75 9.04961 18.205 7.98005C18.0806 7.7358 17.9369 7.50341 17.7759 7.28479L21.25 3.81066V7C21.25 7.41421 21.5858 7.75 22 7.75C22.4142 7.75 22.75 7.41421 22.75 7V2C22.75 1.58579 22.4142 1.25 22 1.25H17C16.5858 1.25 16.25 1.58579 16.25 2ZM17.7759 7.28479C17.4777 6.87994 17.1201 6.52233 16.7152 6.22413L10.75 12.1893V9C10.75 8.58579 10.4142 8.25 10 8.25C9.58579 8.25 9.25 8.58579 9.25 9V14C9.25 14.4142 9.58579 14.75 10 14.75H15C15.4142 14.75 15.75 14.4142 15.75 14C15.75 13.5858 15.4142 13.25 15 13.25H11.8107L17.7759 7.28479Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M11 2H10.5H9.5C7.17029 2 6.00544 2 5.08658 2.3806C3.86144 2.88807 2.88807 3.86144 2.3806 5.08658C2 6.00544 2 7.17029 2 9.5V9.5V10M22 13V13.5V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H9.5C7.17029 22 6.00544 22 5.08658 21.6194C3.86144 21.1119 2.88807 20.1386 2.3806 18.9134C2 17.9946 2 16.8297 2 14.5V14.5V14M22 2H17M22 2V7M22 2L17.5 6.5M10 14V9M10 14H15M10 14L14.5 9.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M11 2H10.5H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V13.5V13M10 14L22 2M10 14V9M10 14H15M22 2H17M22 2V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 5.25C6.44974 5.25 5.04961 5.25 3.98005 5.79497C3.03924 6.27433 2.27433 7.03924 1.79497 7.98005C1.25 9.04961 1.25 10.4497 1.25 13.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H10.75C13.5503 22.75 14.9504 22.75 16.02 22.205C16.9608 21.7257 17.7257 20.9608 18.205 20.02C18.75 18.9504 18.75 17.5503 18.75 14.75V13.25C18.75 10.4497 18.75 9.04961 18.205 7.98005C17.7257 7.03924 16.9608 6.27433 16.02 5.79497C14.9504 5.25 13.5503 5.25 10.75 5.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17 2.75C16.5858 2.75 16.25 2.41421 16.25 2C16.25 1.58579 16.5858 1.25 17 1.25H22C22.4142 1.25 22.75 1.58579 22.75 2V7C22.75 7.41421 22.4142 7.75 22 7.75C21.5858 7.75 21.25 7.41421 21.25 7V3.81066L11.8107 13.25H15C15.4142 13.25 15.75 13.5858 15.75 14C15.75 14.4142 15.4142 14.75 15 14.75H10C9.58579 14.75 9.25 14.4142 9.25 14V9C9.25 8.58579 9.58579 8.25 10 8.25C10.4142 8.25 10.75 8.58579 10.75 9V12.1893L20.1893 2.75H17Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
